export default __webpack_public_path__ + "1866e9f78e3cd940d3805d7d1b061565.svg";